// @flow strict

/* eslint-disable ta-code-conventions/has-matching-storydoc */

import * as React from 'react';
import { OverlayPortal } from '@ta/lithium.portals';
import classNames from '@ta/common.classnames';
import styles from './Backdrop.css';

type Props = {|
  /** Callback fired when the backdrop is clicked */
  onClick?: () => mixed,
  /** The color of the backdrop */
  backdropShade?: 'light' | 'dark',
  /** The content to render within the backdrop */
  children: React.Node,
|};

const Backdrop = ({ children, onClick, backdropShade = 'dark' }: Props) => (
  <>
    <OverlayPortal
      className={classNames(styles.backdrop, {
        [styles.light]: backdropShade === 'light',
      })}
      onClick={onClick}
    />
    {children}
  </>
);

export default Backdrop;
